import { Injectable } from '@angular/core';
import { SyskbServicePkg } from './syskbPkg.service';

@Injectable({
  providedIn: 'root',
})
export class SyskbService extends SyskbServicePkg {
  constructor() {
    super();
  }
}
